var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"mt-2 mb-2",attrs:{"cols":"12","md":"8"}},[_c('BarChart',{attrs:{"title_header":'Gastos / Compras',"data":_vm.compras}})],1),_c('v-col',{staticClass:"mt-2 mb-2",attrs:{"cols":"12","md":"4"}},[_c('PieChart',{attrs:{"title_header":'Compras ',"data":_vm.compra_location}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }